import { useState } from "react";

export const FastLaneCard = ({ sessionId, visitorId, api, user, consentText, onVerified }) => {
  const [phone, setPhone] = useState("");
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${api}/contacts/fastlane`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ session_id: sessionId, visitor_id: visitorId, phone: phone || null, consent_given: true }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "That didn't go through — please try again.");
      setDone(data.message);
      onVerified?.();
    } catch (err) {
      setError(err.message || "That didn't go through — please try again.");
    }
    setBusy(false);
  };

  if (done) {
    return (
      <div className="rounded-2xl border border-[#2E2E2E] bg-[#111111] p-6 max-w-2xl" data-testid="fastlane-success">
        <p className="text-base font-medium text-white leading-[1.6]">{done}</p>
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden rounded-2xl border border-[#2E2E2E] bg-[#111111] p-6 md:p-8 max-w-2xl space-y-4" data-testid="fastlane-card">
      <div className="absolute top-0 left-0 w-full h-1 bg-[#4ADE80]" />
      <p className="text-base font-bold text-[#4ADE80] pt-1">Signed in with Google</p>
      <div className="flex items-center gap-3">
        {user?.picture && <img src={user.picture} alt="" referrerPolicy="no-referrer" className="w-9 h-9 rounded-full border border-[#2E2E2E]" />}
        <div>
          <p className="text-base font-semibold text-white" data-testid="fastlane-identity">{user?.name}</p>
          <p className="text-base font-medium text-[#D6D6D6]">{user?.email}</p>
        </div>
      </div>
      <p className="text-base font-medium text-[#D6D6D6] leading-[1.6]">
        You're signed in, so there's nothing to type. One tap puts you on record and we keep moving.
      </p>
      <input
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="Phone (optional — for texts and calls)"
        data-testid="fastlane-phone-input"
        className="rounded-xl bg-[#050505] border border-[#2E2E2E] px-4 py-3 text-base font-medium text-white placeholder:text-[#D6D6D6] outline-none focus:border-[#4ADE80] w-full transition-colors duration-150"
      />
      <div className="rounded-xl border border-[#2E2E2E] bg-[#050505] p-4">
        <span className="text-base font-medium text-[#D6D6D6] leading-[1.6]">{consentText}</span>
      </div>
      {error && <p className="text-base font-semibold text-[#FF5C5C]" data-testid="fastlane-error">{error}</p>}
      <button onClick={submit} disabled={busy} data-testid="fastlane-submit-button"
        className="rounded-xl bg-[#4ADE80] text-black font-semibold text-base px-8 py-3 hover:bg-[#6ee7a0] disabled:opacity-40 transition-colors duration-150 w-full sm:w-auto">
        {busy ? "One moment..." : "Agree and continue"}
      </button>
      <p className="text-base font-medium text-[#D6D6D6]">Tapping the button gives your express written consent, per the text above.</p>
    </div>
  );
};
